import AppContext from 'App/AppContext';
import { AuditTrailEntryCard } from 'components/Activity/AuditTrailEntryCard';
import { TFunction } from 'i18next';
import AuditTrailEntry from 'models/auditTrailEntry';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
interface ISingleAuditTrailEntry {
  auditTrailEntry: AuditTrailEntry;
}

export const SingleAuditTrailEntry = (props: ISingleAuditTrailEntry) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation([
    'translation',
    'auditTrail',
    'control',
    'risk',
    'adminAuth',
    'library',
    'audit',
    'package',
    'objective',
    'asset',
    'processingActivity',
  ]);

  const expl = props.auditTrailEntry.getActivityText(t as TFunction<string[]>, appContext);

  return (
    <AuditTrailEntryCard
      userId={props.auditTrailEntry.userId}
      userName={props.auditTrailEntry.userName}
      date={props.auditTrailEntry.created}
      text={expl}
    />
  );
};
